import { MdDownload } from "react-icons/md";
import { FaFolderOpen } from "react-icons/fa";
import PProfile from "../../images/profile.jpg";

const Hero = () => {
    return (
        <section className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row gap-8 px-4 pt-16 pb-14 sm:py-20 lg:py-36" id="header">
            <div className="w-full lg:w-1/2 flex flex-col gap-5 sm:gap-6 justify-center text-center lg:text-start">
                <div>
                    <span className="text-3xl sm:text-4xl md:text-5xl block font-semibold">Hello, I'm</span>
                    <h1 className="text-[clamp(2.7rem,8vw,5.5rem)] leading-[0.98] text-primary pridi font-semibold uppercase break-words">Deva Rahma Nugroho</h1>
                    <h2 className="font-semibold text-3xl sm:text-4xl md:text-5xl">Software Engineer</h2>
                </div>
                <p className="text-base sm:text-lg font-light">I live in Indonesia, I'm a responsible person, project what I make will not exceed the specified time limit.</p>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 sm:gap-4">
                    <a href="#projects" className="bg-black px-4 py-3 sm:px-6 lg:px-8 sm:py-4 hover:opacity-95 text-white font-semibold border border-black transition shadow-default active:translate-x-[2px] active:translate-y-[2px] active:shadow-none flex items-center gap-2 text-xs sm:text-sm lg:text-base hover:-translate-y-1">
                        <FaFolderOpen size={20} />
                        VIEW PROJECTS
                    </a>
                    <a href="https://drive.usercontent.google.com/download?id=11UHQSkC01clcODyiTUKjliyohAYVhwz6&export=download&authuser=1&confirm=t&uuid=1e5b0213-f62f-4413-98ce-8257bed13ef6&at=APcXIO2Qd3_UzyFX0ZXN_qji9QoD:1772554284161" target="_blank" rel="noreferrer" className="bg-white px-4 py-3 sm:px-6 lg:px-8 sm:py-4 hover:opacity-95 text-black font-semibold border border-black transition shadow-default active:translate-x-[2px] active:translate-y-[2px] active:shadow-none flex items-center gap-2 text-xs sm:text-sm lg:text-base hover:-translate-y-1">
                        <MdDownload size={20} />
                        DOWNLOAD CV
                    </a>
                </div>
            </div>
            <div className="w-full lg:w-1/2 flex items-center justify-center">
                <img src={PProfile} alt="Profile" loading="lazy" className="h-72 sm:h-[26rem] md:h-[30rem] lg:h-[33rem] max-w-full object-cover rotate-2 hover:rotate-0 saturate-0 hover:saturate-100 bg-white p-3 transition shadow-default border border-black" />
            </div>
        </section>
    )
}

export default Hero
